var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass");

var axios = require('axios');
/**
 * http接口访问区块链节点
 * @constructor
 * @param {string} host - IOST节点的URL
 * @param {number} timeout - 超时时间，以毫秒计时
 */


var HTTPProvider =
/*#__PURE__*/
function () {
  "use strict";

  function HTTPProvider(host, timeout) {
    _classCallCheck(this, HTTPProvider);

    this._host = host || 'http://localhost:30000';
    this._timeout = timeout;
  }
  /**
   * 发送一个http请求，使用promise
   * @param {string}method - get or post
   * @param {string}url - 节点的API
   * @param {string}data - 参数，以json string表示
   * @returns {promise} - 返回response的内容的promise
   */


  _createClass(HTTPProvider, [{
    key: "send",
    value: function send(method, url, data) {
      var config = {
        method: method,
        url: this._host + '/' + url,
        data: data,
        timeout: this._timeout,
        headers: {
          'Content-Type': 'text/plain'
        }
      };
      return axios(config).then(function (response) {
        return response.data;
      }).catch(function (e) {
        if (e.response !== undefined) {
          throw new Error("error: " + JSON.stringify(e.response.data));
        } else {
          throw new Error("error: " + e);
        }
      });
    }
  }]);

  return HTTPProvider;
}();

module.exports = HTTPProvider;